var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biyezheng-page"},[_c('div',{staticClass:"goback",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")]),_vm._v(" "),_c('img',{staticClass:"head-img",attrs:{"src":_vm.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"ewm-box"},[_c('QRCodeCanvas',{attrs:{"msg":_vm.imgUrl}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7162d35e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/biyezheng.vue
// module id = null
// module chunks = 